import type { SiteEntity } from '../../types/site';
import { hashCanonicalJson } from '../reportGeneration/reportContractHash';

/** Semantic source revision: preserves curation and extraction changes, omits embedding/status telemetry. */
export function computeDocumentSourceIdentity(site: Pick<SiteEntity, 'documents' | 'siteContext' | 'demonstrationProvenance'>): string {
  return hashCanonicalJson({ version: 'sed-document-context-v1',
    documents: (site.documents ?? []).filter(doc => !doc.tags?.includes('library-index')).map(doc => ({
      id: doc.id, contentHash: doc.contentHash, storagePath: doc.storagePath, rawStoragePath: doc.rawStoragePath,
      uploadedAt: doc.uploadedAt, updatedAt: doc.updatedAt, includeInSed: doc.includeInSed, includeInReport: doc.includeInReport,
      deletedAt: doc.deletedAt, archived: doc.archived, tags: doc.tags,
      textContent: doc.textContent, summary: doc.summary, extractedCharsTotal: doc.extractedCharsTotal,
      needsOcr: doc.needsOcr, truncated: doc.truncated, evidenceDigest: doc.evidenceDigest,
      // Older intake rows can retain the SED content index as an extension.
      contentIndex: (doc as typeof doc & { contentIndex?: unknown }).contentIndex,
      generationScreeningExtraction: doc.generationScreeningExtraction,
      ...(doc.demonstrationProvenance ? { demonstrationProvenance: doc.demonstrationProvenance } : {}),
    })).sort((a, b) => a.id.localeCompare(b.id)),
    siteContext: site.siteContext ?? null,
    ...(site.demonstrationProvenance ? { demonstrationProvenance: site.demonstrationProvenance } : {}),
  });
}
